import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.sidebar');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.sidebar/view.scss */
/* src/app/layout.sidebar/view.scss: no such file or directory */`],
})
export class LayoutSidebarComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const status = this.service.status as any;
        if (status.navbar === undefined) status.navbar = false;
        if (status.sidebarCollapsed === undefined) status.sidebarCollapsed = false;
        await this.service.render();
    }

    @HostListener('document:click')
    public async clickout() {
        if ((this.service.status as any).navbar) {
            await this.service.status.toggle('navbar', false);
        }
    }

    public get navbarOpen(): boolean {
        return !!(this.service.status as any).navbar;
    }

    public get sidebarCollapsed(): boolean {
        return !!(this.service.status as any).sidebarCollapsed;
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }
}

export default LayoutSidebarComponent;